module.exports = __webpack_public_path__ + "img/candidategraph.e73208b8.svg";